import { ASSETS } from '../../config/assets';

/**
 * Dominoes-only brand mark (Figma "Mask group", 197.5×173.5 ×0.75) — the
 * small icon above the heading on Login/Forgot Password's narrow auth
 * cards. Extracted from the approved LoginScreen.
 */
export function AuthBrandMark({ height = 130 }: { height?: number }) {
  return (
    <img
      src={ASSETS.brand.ICON}
      alt="The Domino Game"
      style={{ height, width: 'auto', objectFit: 'contain' }}
      draggable={false}
    />
  );
}
